<template>
    <div class="left_panel">
        <h2
            class="font_size_20 font-weight-bold mb-0 text_black edit_profile_heading"
        >
            Edit Profile
        </h2>
        <div class="subhead font_size_16 text_light_grey mb-0">
            View and manage your profile
        </div>
        <form
            method="post"
            @submit.prevent="onSubmitToUpdate"
            data-vv-scope="edit-profile"
            :key="'edit-profile'"
        >
            <div class="row">
                <div class="col-md-12 accordian_with_form">
                    <div class="accordion mt_30" id="accordionExample">
                        <div class="card personal_information_card">
                            <div class="card-header p-0" id="headingOne">
                                <h2
                                    class="mb-0 accordian_heading text-left d-flex"
                                    data-toggle="collapse"
                                    data-target="#collapseOne"
                                    aria-expanded="true"
                                    aria-controls="collapseOne"
                                >
                                    Personal Information
                                    <span class="ml-auto my-auto minus">
                                        <img
                                            src="/maincss/images/minus.svg"
                                            alt=" "
                                        />
                                    </span>
                                    <span class="ml-auto my-auto plus">
                                        <img
                                            src="/maincss/images/plus.svg"
                                            alt=" "
                                        />
                                    </span>
                                </h2>
                            </div>
                            <div
                                id="collapseOne"
                                class="collapse show"
                                aria-labelledby="headingOne"
                                data-parent="#accordionExample"
                            >
                                <div class="card-body edit_profile_card_body">
                                    <div class="row edit_name_row">
                                        <div
                                            class="col-md-12 col-lg-6 pr_34 mobile_pr_15"
                                        >
                                            <div class="form-group">
                                                <label>User Type</label>
                                                <span class="highlight"></span>
                                                <v-select
                                                    label="name"
                                                    :options="user_type"
                                                    v-model="user.user_type"
                                                    v-validate="'required'"
                                                    data-vv-as="User Type"
                                                    name="user_type"
                                                ></v-select>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'edit-profile.user_type'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "edit-profile.user_type"
                                                        )
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="row mt_44"
                                        v-if="user.user_type == 'Business'"
                                    >
                                        <div
                                            class="col-md-12 col-lg-6 pr_34 mobile_pr_15"
                                        >
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="business_name"
                                                    name="business_name"
                                                    placeholder="Enter Business Name"
                                                    class="form-control bg-transparent"
                                                    v-model="user.business_name"
                                                    v-validate="
                                                        user.user_type ==
                                                        'Business'
                                                            ? 'required|max:100'
                                                            : ''
                                                    "
                                                    data-vv-as="Business Name"
                                                />
                                                <label>Business Name</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'edit-profile.business_name'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "edit-profile.business_name"
                                                        )
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-12 col-lg-6 pl_34 mobile_pl_15 pr_46 mobile_pr_0"
                                        >
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="Email"
                                                    autocomplete="off"
                                                    disabled
                                                    placeholder="Enter Email"
                                                    class="form-control bg-transparent"
                                                    v-model="user.email"
                                                />
                                                <label>Email address</label>
                                                <span class="highlight"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="row mt_44"
                                        v-if="user.user_type == 'Business'"
                                    >
                                        <div
                                            class="col-md-12 col-lg-6 pr_34 mobile_pr_15"
                                        >
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="first_name"
                                                    name="first_name"
                                                    placeholder="Enter First Name"
                                                    class="form-control bg-transparent"
                                                    v-model="user.first_name"
                                                    v-validate="
                                                        'required|max:100'
                                                    "
                                                    data-vv-as="First Name"
                                                />
                                                <label>First name</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'edit-profile.first_name'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "edit-profile.first_name"
                                                        )
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-12 col-lg-6 pl_34 mobile_pl_15 pr_46 mobile_pr_0"
                                        >
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="last_name"
                                                    name="last_name"
                                                    placeholder="Enter Last Name"
                                                    class="form-control bg-transparent"
                                                    v-model="user.last_name"
                                                    v-validate="
                                                        'required|max:100'
                                                    "
                                                    data-vv-as="Last Name"
                                                />
                                                <label>Last name</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'edit-profile.last_name'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "edit-profile.last_name"
                                                        )
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="row mt_44"
                                        v-if="user.user_type == 'Individual'"
                                    >
                                        <div
                                            class="col-md-12 col-lg-6 d-flex pr_34 mobile_pr_15"
                                        >
                                            <div
                                                class="form-group w-50 pr_24 mobile_pr_0"
                                            >
                                                <input
                                                    type="text"
                                                    id="first_name"
                                                    name="first_name"
                                                    placeholder="Enter First Name"
                                                    class="form-control bg-transparent"
                                                    v-model="user.first_name"
                                                    v-validate="
                                                        'required|max:100'
                                                    "
                                                    data-vv-as="First Name"
                                                />
                                                <label>First name</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'edit-profile.first_name'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "edit-profile.first_name"
                                                        )
                                                    }}</small
                                                >
                                            </div>
                                            <div
                                                class="form-group w-50 pl_24 mobile_pl_0"
                                            >
                                                <input
                                                    type="text"
                                                    id="last_name"
                                                    name="last_name"
                                                    placeholder="Enter Last Name"
                                                    class="form-control bg-transparent"
                                                    v-model="user.last_name"
                                                    v-validate="
                                                        'required|max:100'
                                                    "
                                                    data-vv-as="Last Name"
                                                />
                                                <label class="pl_24 mobile_pl_0"
                                                    >Last name</label
                                                >
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'edit-profile.last_name'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "edit-profile.last_name"
                                                        )
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-12 col-lg-6 pl_34 mobile_pl_15 pr_46 mobile_pr_0"
                                        >
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="Email"
                                                    autocomplete="off"
                                                    disabled
                                                    placeholder="Enter Email"
                                                    class="form-control bg-transparent"
                                                    v-model="user.email"
                                                />
                                                <label>Email address</label>
                                                <span class="highlight"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt_44">
                                        <div
                                            class="col-md-12 col-lg-6 pr_34 mobile_pr_15"
                                        >
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="shirt_size"
                                                    name="shirt_size"
                                                    class="form-control bg-transparent"
                                                    v-model="user.shirt_size"
                                                    placeholder="Enter My Shirt Size"
                                                    data-vv-as="My Shirt Size"
                                                />
                                                <label>My Shirt Size</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'edit-profile.shirt_size'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "edit-profile.shirt_size"
                                                        )
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt_44">
                                        <div
                                            class="col-md-12 col-lg-6 pr_34 mobile_pr_15"
                                        >
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="phone_no"
                                                    name="phone_no"
                                                    class="form-control bg-transparent"
                                                    v-model="
                                                        user.Profile.phone_no
                                                    "
                                                    v-validate="
                                                        'required|length:14'
                                                    "
                                                    data-vv-as="Phone number"
                                                    placeholder="Enter Phone Number"
                                                    autocomplete="off"
                                                    v-mask="'(###) ###-####'"
                                                />
                                                <label>Phone number</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'edit-profile.phone_no'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "edit-profile.phone_no"
                                                        )
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-12 col-lg-6 pl_34 mobile_pl_15 pr_46 mobile_pr_0"
                                        >
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="mobile"
                                                    name="mobile"
                                                    class="form-control bg-transparent"
                                                    v-model="user.mobile"
                                                    v-validate="
                                                        'required|min:12'
                                                    "
                                                    data-vv-as="Mobile"
                                                    autocomplete="off"
                                                    @input="acceptNumber"
                                                    placeholder="Enter Mobile Number"
                                                />
                                                <label>Mobile</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'edit-profile.mobile'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "edit-profile.mobile"
                                                        )
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mt_44">
                                        <div
                                            class="col-md-12 pr_46 mobile_pr_0"
                                        >
                                            <div
                                                class="form-group add_business_schl_custom"
                                            >
                                                <label
                                                    >Add Business/School Name
                                                    2</label
                                                >
                                                <span class="highlight"></span>

                                                <!--   <input
                                                    mb-0
                                                    type="text"
                                                    id="school_business"
                                                    name="school_business"
                                                    autocomplete="off"
                                                    placeholder="Enter Business/School Name"
                                                    class="form-control bg-transparent mb-0"
                                                    v-model="
                                                        user.Profile
                                                            .school_business
                                                    "
                                                    data-vv-as="Business/School Name"
                                                /> -->

                                                <!-- Hidden trap fields -->
                                                <input
                                                    type="text"
                                                    name="fakeusernameremembered"
                                                    style="display: none"
                                                />
                                                <input
                                                    type="password"
                                                    name="fakepasswordremembered"
                                                    style="display: none"
                                                />

                                                <!-- Your real field -->
                                                <input
                                                    type="text"
                                                    id="school_business"
                                                    name="school_business"
                                                    placeholder="Enter Business/School Name"
                                                    class="form-control bg-transparent mb-0"
                                                    v-model="
                                                        user.Profile
                                                            .school_business
                                                    "
                                                    :autocomplete="'off'"
                                                    data-vv-as="Business/School Name"
                                                />

                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'edit-profile.school_business'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "edit-profile.school_business"
                                                        )
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="box_checkbox bg_primary_light_white change_password_edit_pro mt_20"
                    >
                        <div class="form-check pl-0 py_6 d-flex">
                            <label
                                class="checkbox_custom mb-0 font_size_18 text_primary_blue"
                            >
                                Change Password
                                <input
                                    type="checkbox"
                                    v-model="user.is_change_pssword"
                                />
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="row" v-show="user.is_change_pssword">
                            <div class="col-md-12 col-lg-6">
                                <div class="form-group">
                                    <input
                                        autocomplete="off"
                                        type="password"
                                        class="form-control bg-transparent"
                                        id="Password2"
                                        name="password"
                                        v-model="user.new_password"
                                        v-validate="
                                            user.is_change_pssword
                                                ? 'required|min:6|max:8'
                                                : ''
                                        "
                                        ref="password"
                                        placeholder="Enter Password"
                                    />
                                    <label>Password</label>
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <small
                                        class="form-text text-error text-left"
                                        v-show="
                                            errors.has('edit-profile.password')
                                        "
                                        >{{
                                            errors.first(
                                                "edit-profile.password"
                                            )
                                        }}</small
                                    >
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-6">
                                <div class="form-group">
                                    <input
                                        type="password"
                                        class="form-control bg-transparent"
                                        id="Password3"
                                        name="confirm_password"
                                        v-model="user.confirm_password"
                                        placeholder="Enter Confirm Password"
                                        v-validate="
                                            user.is_change_pssword
                                                ? 'required|min:6|max:8|confirmed:password'
                                                : ''
                                        "
                                        data-vv-as="confirm password"
                                    />
                                    <label>Confirm Password</label>
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <small
                                        class="form-text text-error text-left"
                                        v-show="
                                            errors.has(
                                                'edit-profile.confirm_password'
                                            )
                                        "
                                        >{{
                                            errors.first(
                                                "edit-profile.confirm_password"
                                            )
                                        }}</small
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 text-right">
                    <div class="buttons edit_profile_btn mt_48 ml-auto">
                        <router-link
                            :to="{ name: 'Myorder' }"
                            class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_52 mr_34"
                            >Cancel</router-link
                        >
                        <button
                            type="submit"
                            class="btn btn_orange bg_primary_orange text_white py_18 px_52"
                        >
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <div class="preloader" v-show="isBusy">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon class="rect" points="0 0 0 40 40 40 40 0" />
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import { mask } from "vue-the-mask";
import { CHECK_AUTH } from "@/store/actions.type";

export default {
    name: "EditProfile",
    directives: { mask },
    components: {},
    data() {
        return {
            user: {
                Profile: {},
                user_type: "Individual"
            },
            all_states: [],
            all_address: [],
            address_data: [],
            user_type: ["Individual", "Business"],
            business_school: [
                {
                    id: "1",
                    name: "School 1"
                },
                {
                    id: "2",
                    name: "School 2"
                },
                {
                    id: "3",
                    name: "School 3"
                }
            ],
            isBusy: false
        };
    },
    beforeMount() {
        this.isBusy = true;
    },
    mounted() {
        this.getUser();
        document.body.classList.add("bg_primary_light_white");
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
        const dict = {
            custom: {
                phone_no: {
                    length: "Phone Number must be 10 digits."
                },
                mobile: {
                    length: "Mobile Number must be 10 digits except country code."
                }
            }
        };
        // or use the instance method
        this.$validator.localize("en", dict);

        this.getStates();
        this.getAddresses();
    },
    methods: {
        getUser() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/user-profile")
                    .then(({ data }) => {
                        this.user = data.user;
                        this.user.Profile = this.user.Profile
                            ? this.user.Profile
                            : {};
                        this.isBusy = false;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        onSubmitToUpdate() {
            var _this = this;
            this.$validator.validateAll("edit-profile").then((isValid) => {
                if (isValid) {
                    _this.isBusy = true;
                    new Promise(() => {
                        ApiService.setHeader();
                        console.log(_this.user);

                        _this.address_data = {
                            address1: _this.user.Profile.address_1,
                            address2: _this.user.Profile.address_2,
                            state: _this.user.Profile.state,
                            city: _this.user.Profile.city,
                            pincode: _this.user.Profile.zipcode
                        };
                        ApiService.put("/update-profile", _this.user)
                            .then(({ data }) => {
                                _this.isBusy = false;

                                if (data.success) {
                                    _this.address_book();
                                    _this.$toast.clear();
                                    _this.$toast.success(
                                        "Profile Updated Successfully",
                                        {
                                            position: "top-right"
                                        }
                                    );
                                    new Promise.all([
                                        _this.$store.dispatch(CHECK_AUTH)
                                    ]);
                                }
                            })
                            .catch(({ response }) => {
                                console.log(response);
                                _this.isBusy = false;
                            });
                    });
                } else {
                    console.log("gjhghj", this.errors);
                }
            });
        },
        getAddresses() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/all-addresses")
                    .then(({ data }) => {
                        _this.all_address = data.address;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        address_book() {
            var value = this.all_address.filter((item) => {
                return (
                    item.address1 == this.address_data.address1 &&
                    item.address2 == this.address_data.address2 &&
                    item.city == this.address_data.city &&
                    item.state == this.address_data.state &&
                    item.zipcode == this.address_data.zipcode
                );
            });
            if (value.length == 0) {
                new Promise(() => {
                    ApiService.post("/address-book", this.address_data).then(
                        () => {
                            this.getAddresses();
                        }
                    );
                });
            }
        },
        getStates() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/states")
                    .then(({ data }) => {
                        _this.all_states = data.states;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                    });
            });
        },
        acceptNumber() {
            var x = this.user.mobile
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.user.mobile = !x[2]
                ? x[1]
                : "" + x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
        }
    },
    computed: {
        ...mapGetters(["currentUserClient", "isAuthenticatedClient"])
    }
};
</script>
